import React from "react";
import { Link } from "react-router-dom";

const Home = () => {
  return (
    <div className="flex flex-col items-center justify-center w-full h-full pb-[5.5vh] sm:pb-[5vh] pl-[2.5vw]">
      {/* Parent Flexbox to Ensure Consistent Spacing */}
      <div className="flex flex-col items-center w-full max-w-[60rem] gap-[3.2vh]">
        {/* Top Group: Name, Subtitle, and Headshot */}
        <div className="flex flex-col sm:flex-row items-center sm:justify-center">
          {/* Left Section: Name and Subtitle */}
          <div className="flex flex-col items-center sm:items-end sm:pr-[2rem]">
            {/* Name */}
            <div className="text-[5.5rem] sm:text-[7rem] md:text-[8rem] lg:text-[6.8rem] xl:text-[8rem] font-garamond font-bold text-center sm:text-right leading-[5.5rem] sm:leading-[6.7rem] md:leading-[7.68rem]">
              Aaron <br /> Zhu
            </div>

            {/* Subtitle */}
            <div className="text-[1.8rem] sm:text-[2.2rem] md:text-[2.45rem] lg:text-[2rem] xl:text-[2.45rem] font-garamond font-bold text-center sm:text-right">
              Software Engineer
            </div>
          </div>

          {/* Right Section: Headshot */}
          <div className="mt-[1.5rem] sm:mt-[-0.76rem] sm:ml-[-2.4rem] lg:mt-[-0.36rem] xl:mt-[-0.76rem]">
            <img
              src="/headshot.png"
              alt="Aaron Zhu Headshot"
              className="w-[12rem] sm:w-[14rem] md:w-[17.8rem] lg:w-[17.2rem] xl:w-[17.8rem] h-auto border-t-white border-l-white border-b-[#828282] border-r-[#828282]"
            />
          </div>
        </div>

        {/* Single entry point; the sidebar on the next page links to everything else */}
        <Link
          to="/about"
          className="mt-[1vh] px-8 py-2 bg-[#c0c0c0] font-garamond font-bold text-[1.3rem] sm:text-[1.5rem] border-[0.15rem] border-t-white border-l-white border-b-black border-r-black active:border-t-black active:border-l-black active:border-b-white active:border-r-white"
        >
          Read More
        </Link>
      </div>
    </div>
  );
};

export default Home;
